(() => {
  if (window.CBHCollectionDirectory) return;

  const rootSelector = "[data-cbh-collection-directory]";

  const normalise = (value) => {
    const text = String(value || "").toLowerCase();

    if (typeof text.normalize === "function") {
      return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    return text;
  };

  const initialise = (root) => {
    if (!root || root.dataset.collectionDirectoryReady === "true") return;

    const input = root.querySelector("[data-collection-directory-search]");
    const inputClear = root.querySelector(
      ".cbh-collection-directory__search [data-collection-directory-clear]",
    );
    const clearButtons = root.querySelectorAll(
      "[data-collection-directory-clear]",
    );
    const status = root.querySelector("[data-collection-directory-status]");
    const emptyState = root.querySelector("[data-collection-directory-empty]");
    const items = Array.from(
      root.querySelectorAll("[data-collection-directory-item]"),
    );
    const groups = Array.from(
      root.querySelectorAll("[data-collection-directory-group]"),
    );
    const letterLinks = Array.from(
      root.querySelectorAll("[data-collection-directory-letter]"),
    );

    if (!input || !status || !items.length || !groups.length) return;

    root.dataset.collectionDirectoryReady = "true";

    const total = Number(status.dataset.total || items.length);
    const resultLabel = (count) =>
      `${count} ${count === 1 ? "collection" : "collections"}`;

    const applyFilter = () => {
      const query = normalise(input.value).trim();
      let visibleCount = 0;
      const visibleLetters = new Set();

      items.forEach((item) => {
        const searchValue = normalise(item.dataset.search);
        const matches = query === "" || searchValue.includes(query);

        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      groups.forEach((group) => {
        const hasVisibleItem = Array.from(
          group.querySelectorAll("[data-collection-directory-item]"),
        ).some((item) => !item.hidden);

        group.hidden = !hasVisibleItem;
        if (hasVisibleItem)
          visibleLetters.add(group.dataset.collectionDirectoryGroup);
      });

      letterLinks.forEach((link) => {
        link.hidden =
          query !== "" &&
          !visibleLetters.has(link.dataset.collectionDirectoryLetter);
      });

      status.textContent =
        query === ""
          ? resultLabel(total)
          : `${resultLabel(visibleCount)} matching “${input.value.trim()}”`;

      if (inputClear) inputClear.hidden = query === "";
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    };

    const clearFilter = () => {
      input.value = "";
      applyFilter();
      input.focus();
    };

    input.addEventListener("input", applyFilter);
    input.addEventListener("search", applyFilter);
    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && input.value) {
        event.preventDefault();
        clearFilter();
      }
    });

    clearButtons.forEach((button) => {
      button.addEventListener("click", clearFilter);
    });

    applyFilter();
  };

  const initialiseWithin = (container) => {
    if (!container) return;
    if (container.matches && container.matches(rootSelector))
      initialise(container);
    container.querySelectorAll?.(rootSelector).forEach(initialise);
  };

  window.CBHCollectionDirectory = { initialiseWithin };
  initialiseWithin(document);

  document.addEventListener("shopify:section:load", (event) => {
    initialiseWithin(event.target);
  });
})();
